import { render } from "./UnselectSelectedItemsDialog.vue?vue&type=template&id=02485db7"
import script from "./UnselectSelectedItemsDialog.vue?vue&type=script&lang=js"
export * from "./UnselectSelectedItemsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__